module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "kp-list-item"
  }, [_c('div', {
    staticClass: "kp-folder-name"
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.box.name
    },
    on: {
      "change": function($event) {
        _vm.boxesSetName(({
          event: $event,
          id: _vm.box.id
        }))
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-testab"
  }), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-updatedate"
  }, [_c('locale-date', {
    attrs: {
      "date": _vm.box.updated_at
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-status"
  }), _vm._v(" "), _c('button-delete', {
    attrs: {
      "box": _vm.box,
      "index": _vm.index
    }
  }), _vm._v(" "), _c('button-edit', {
    attrs: {
      "box": _vm.box
    }
  }), _vm._v(" "), _c('button-report', {
    attrs: {
      "box": _vm.box
    }
  }), _vm._v(" "), _c('button-export', {
    attrs: {
      "box": _vm.box
    }
  })], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4be37230!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/item/Main.vue
 ** module id = 820
 ** module chunks = 1
 **/